"use client";
import { useEffect, useRef } from "react";
import { ChevronDown } from 'lucide-react'
import { useTranslations } from 'next-intl';
import FloatingTitle from "@/app/components/ui-elements/text/FloatingTitle";

export default function Hero() {
  const t = useTranslations('Home');
  const headlineRef = useRef<HTMLHeadingElement>(null);
  const subRef = useRef<HTMLParagraphElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    import("gsap").then(({ gsap }) => {
      const tl = gsap.timeline();
      tl.from(headlineRef.current, {
        opacity: 0.2,
        y: 50,
        duration: 1,
        ease: "power3.out",
      })
        .from(subRef.current, {
          opacity: 0,
          y: 30,
          duration: 1,
        }, "-=0.5")
        .from(buttonRef.current, {
          opacity: 0,
          y: 20,
          duration: 1,
        }, "-=0.5");
    })
  }, []);



  return (
    <section className="relative bg-gradient-dark text-white pt-14" style={{ contentVisibility: 'auto' }}>
      <section className="relative w-full h-screen flex items-center justify-center overflow-hidden  text-white pt-14" style={{ contentVisibility: 'auto' }}>
        <div className="relative z-10 text-center">
          {/* Title */}
          <FloatingTitle text="Primalt" classname="hero-title font-bold" ref={headlineRef} />
          <div className="flex justify-end mt-0 md:-mt-14">
            <p ref={subRef} className="text-sm md:text-md lg:text-base mb-6 text-start">
              {t('subtitle1')}
              <br />{t('subtitle2')}
              <br />{t('subtitle3')}
            </p>
          </div>
        </div>
        <div className="absolute bottom-1 left-1/2 -translate-x-1/2">
          <a href="#what-we-do" className="flex flex-col items-center text-white">
            <ChevronDown
              size={30}
              className="animate-bounce text-white"
            />
            <span ref={buttonRef} className="mb-2 text-sm tracking-wide">{t('what_we_do')}</span>
          </a>
        </div>
      </section>
    </section>
  );
}
